<template>
  <v-card class="ma-2">
    <v-img
      height="200px"
      :src="member.coverPicture"
      class="primary darken-2" />
    <v-layout column>
      <v-avatar
        :size="avatarSize"
        class="mx-auto primary"
        :style="`margin-top: -${avatarSize / 2}px;`"
      >
        <v-img :src="member.profilePicture" />
      </v-avatar>
      <v-card-title class="mx-auto pt-4 pb-0">
        {{ name(member) }}
      </v-card-title>
      <p v-if="subtitle" class="subheading mx-auto my-0 pb-0">
        {{ subtitle }}
      </p>
      <v-card-actions class="ma-0">
        <v-spacer />
        <v-btn icon router :to="id" append>
          <v-icon>mdi-pencil</v-icon>
        </v-btn>
        <v-btn icon @click="$emit('delete', id, name(member))">
          <v-icon>mdi-delete</v-icon>
        </v-btn>
        <v-spacer />
      </v-card-actions>
    </v-layout>
  </v-card>
</template>

<script>
import { FbMember, FbGroup } from '../constants'
import FbMemberMixin from '../mixins/fb-member'

export default {
  name: 'FbMemberListItem',
  mixins: [FbMemberMixin],
  props: {
    id: String,
    type: String,
    member: Object
  },
  data() {
    return {
      avatarSize: 128
    }
  },
  computed: {
    subtitle() {
      if (this.type === FbMember.Page) {
        return this.member.category
      } else if (this.type === FbMember.Group) {
        return {
          [FbGroup.Public]: 'Public',
          [FbGroup.Closed]: 'Closed',
          [FbGroup.Secret]: 'Secret'
        }[this.member.type]
      }

      return ''
    }
  }
}
</script>